import { WHATSAPP_URL } from "@/constants/contact";
import {
  AAIT_HOME_URL,
  footerImportantLinks,
  footerLegalLinks,
  footerServiceLinks,
  socialLinks,
} from "@/constants/aaitSite";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative border-t border-white/5 bg-[#020617]/80 backdrop-blur-xl">
      <div className="container-main px-4 md:px-8 py-14 md:py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <a
              href={AAIT_HOME_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mb-4"
            >
              <img
                src="/logo.png?v=2"
                alt="أوامر الشبكة"
                className="h-20 w-auto brightness-110"
              />
            </a>
            <p className="text-slate-500 text-sm leading-relaxed mb-4">
              شركة برمجيات سعودية متخصصة في تصميم وبرمجة المواقع الإلكترونية
              والتطبيقات.
            </p>
            <div className="flex flex-wrap items-center gap-2">
              {socialLinks.map((social) => (
                <a
                  key={social.href}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center hover:bg-teal-500/20 hover:border-teal-400/30 transition-all"
                >
                  <i
                    className={`${social.icon} text-slate-400 hover:text-teal-400 text-sm`}
                  />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-bold text-sm text-white mb-4">روابط مهمة</h4>
            <ul className="space-y-2.5">
              {footerImportantLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-slate-500 text-sm hover:text-teal-400 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-sm text-white mb-4">ابرز الخدمات</h4>
            <ul className="space-y-2.5">
              {footerServiceLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-slate-500 text-sm hover:text-teal-400 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-sm text-white mb-4">
              بيانات التواصل
            </h4>
            <ul className="space-y-3 text-slate-500 text-sm">
              <li className="flex items-center gap-2">
                <i className="ri-whatsapp-line text-teal-400" />
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-teal-400"
                  dir="ltr"
                >
                  +966 92 000 5929
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-teal-400" />
                <a href="mailto:info@aait.sa" className="hover:text-teal-400">
                  info@aait.sa
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-teal-400" />
                الرياض، المملكة العربية السعودية
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-600 text-xs">
            © {currentYear} أوامر الشبكة AAIT. جميع الحقوق محفوظة.
          </p>
          <div className="flex items-center gap-4">
            {footerLegalLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-600 text-xs hover:text-slate-400 transition-colors"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
